module.exports = __webpack_public_path__ + "static/img/3.1b5d545.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/3.png
// module id = uvcL
// module chunks = 0